import { AUTH_KEY } from '../consts/auth'

export const removeAuthStorages = () => {
    localStorage.removeItem(`${AUTH_KEY}`)
    localStorage.removeItem(`${AUTH_KEY}_refresh`)
    localStorage.removeItem(`${AUTH_KEY}_refresh_time`)
    localStorage.removeItem(`${AUTH_KEY}_state`)
    localStorage.removeItem(`${AUTH_KEY}_type`)
}